import React, { useMemo, useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";

import ErrorBoundary from './utils/ErrorBoundary';

import PDParentStreak from './PDParentStreak';
import PDLocalStreak from './PDLocalStreak';
import PDDOORIContest from './PDDOORIContest';

// import CarHorn from "./utils/CarHorn";

const TABS = [
  { key: "india1", label: "India Crysta" },
//   { key: "india2", label: "India Ferrari" },  
  { key: "global", label: "Global Ferrari" },
//   { key: "gcc", label: "GCC" },
//   { key: "mena", label: "MENA" },
//   { key: "europe", label: "Europe" },
//   { key: "usa", label: "USA" },
//   { key: "asia-pacific", label: "Asia Pacific" },
];

const PDContest = () => {
    const authState = useSelector((state) => state.authReducer);
    const [fetchData] = useFetch();
    const userId = authState?.user?._id;
    const userCode = authState?.user?.think5whyscode;
    const [activeTab, setActiveTab] = useState("india1");
    const [activeView, setActiveView] = useState("contest");
    const [viewTab, setViewTab] = useState(false);
    const [loading, setLoading] = useState(false);

    const [showTransparency, setShowTransparency] = useState(false);

    const [data, setData] = useState(null);
    const hasFetchedTodosRef = useRef(false);
    const [message, setMessage] = useState({ text: '', type: '' });
    const showMessage = (text, type = "success") => {
        setMessage({ text, type });
    };

    const [enableHorn, setEnableHorn] = useState(false);

    useEffect(() => {
        const unlockHorn = () => {
            setEnableHorn(true);

            document.removeEventListener("click", unlockHorn);
            document.removeEventListener("touchstart", unlockHorn);
        };

        document.addEventListener("click", unlockHorn);
        document.addEventListener("touchstart", unlockHorn);

        return () => {
            document.removeEventListener("click", unlockHorn);
            document.removeEventListener("touchstart", unlockHorn);
        };
    }, []);

    const fetchContest = async () => {
     setLoading(true);
    
    const contestCountry =
        activeTab === "india1" || activeTab === "india2"
            ? "india"
            : "global";

        try {
            const config = {
            url: "/pd/contest/bytype",
            method: "post",
            data: { type: contestCountry },
            headers: { Authorization: authState.token },
            };

            const response = await fetchData(config, { silent: true });

            // console.log("response:", response);

            if (response?.success && response?.data) {
            setData(response.data);
            } else {
            setData(null); // IMPORTANT
            }

        } catch (error) {
            console.error("Fetch Contest Error:", error);
            setData(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchContest(activeTab);
    }, [activeTab]);

  return (
    <ErrorBoundary>
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white px-3 py-2">
      {/* <CarHorn
            runEvery={20000}   // every 20 sec
            driveTime={6000}   // 6 sec drive
            enableHorn={enableHorn}
        /> */}
      <div className="text-center mb-2">
        <h1 className="text-sm lg:text-lg font-bold text-cyan-200 tracking-wide">
          PurpleDoor Contest Hub
        </h1>
        <p className="text-xs lg:text-sm  text-gray-200 mt-1">
          PurpleDoor & LifeReplay Streak by Think5Whys, Parents/ Mentors/ Institutions/ Corporate/ Government and Merchants Rewards
        </p>
      </div>
      <div className="relative overflow-hidden rounded-2xl border border-amber-500/30 bg-gradient-to-br from-amber-900/20 via-gray-900 to-purple-900/20 p-2 shadow-lg">
        <div className="absolute top-0 right-0 w-24 h-24 bg-amber-500/10 rounded-full blur-2xl"></div>
            <div className="relative z-10">
                <div
                    onClick={() => setShowTransparency(prev => !prev)}
                    className="flex items-center justify-between gap-2 mb-1 p-2 rounded-lg cursor-pointer hover:bg-cyan-500/10 transition-all select-none"
                >
                    <h3 className="text-xs lg:text-sm font-bold uppercase tracking-wider text-cyan-200">
                        ✅ Transparency First - Transparent Gamified Adoption
                    </h3>
                    <i
                        className={`fa-solid ${
                            showTransparency ? "fa-chevron-up" : "fa-chevron-down"
                        } text-cyan-300 text-xs transition-transform duration-300`}
                    ></i>
                </div>

                {showTransparency && (
                    <>
                        <ul className="space-y-2 text-left">
                            {[
                                "🚀 We’re a startup building step by step.",
                                "🚗 Car rewards for streak winners are not funded from subscription income.",
                                "📈 Rewards are planned from overall business revenue as part of our growth and marketing investment.",
                                "🤝 We believe in transparency and sharing our journey openly with the community that powers it."
                            ].map((item, i) => (
                                <li
                                    key={i}
                                    className={`text-gray-100 text-xs lg:text-sm px-3 py-2 rounded-lg border-l-4 border-cyan-400 leading-relaxed ${
                                        i % 2 === 0 ? "bg-gray-800/60" : "bg-gray-900"
                                    }`}
                                >
                                    {item.includes("step by step") ? (
                                        <>
                                            🚀 We’re a startup building <span className="font-semibold text-white">step by step</span>.
                                        </>
                                    ) : (
                                        item
                                    )}
                                </li>
                            ))}
                        </ul>

                        <p className="text-xs lg:text-sm text-cyan-200 leading-relaxed mt-3">
                            Rewards grow with community participation.
                        </p>

                        <ul className="space-y-2 text-left mt-2">
                            {[
                                "⏳ Below 50% overall business achievement, the contest will be terminated.",
                                "📱 At 50%+, 5 smartphone winners may be selected.",
                                "💻 At 70%+, 5 laptop winners may be selected.",
                                "🛵 At 90%+, 5 scooter winners may be selected.",
                                "🚗 At 100%+, 1 grand winner will receive the Car."
                            ].map((item, i) => (
                                <li
                                    key={i}
                                    className={`text-gray-100 text-xs lg:text-sm px-3 py-2 rounded-lg border-l-4 border-cyan-400 leading-relaxed ${
                                        i % 2 === 0 ? "bg-gray-800/60" : "bg-gray-900"
                                    }`}
                                >
                                    {item}
                                </li>
                            ))}
                        </ul>

                        <div className="mt-3 flex flex-col p-2 border-t border-gray-500">
                            <p className="text-xs lg:text-sm text-cyan-200 leading-relaxed">
                                🌟 Mega Prize: Toyota Innova Crysta Top Model for India and Ferrari Amalfi for Only Global Participants Outside India*.
                            </p>

                            <p className="text-xs lg:text-sm text-gray-200 leading-relaxed mt-2">
                                (Subject to contest terms, eligibility, and achievement milestones.)
                            </p>

                            <p className="text-xs lg:text-sm text-yellow-200 leading-relaxed mt-2">
                                All rewards are funded through overall business revenue and allocated marketing budgets, ensuring complete transparency.
                            </p>
                        </div>

                        <div className="mt-3 flex flex-wrap gap-2">
                            <span className="px-2 py-1 rounded-full text-xs lg:text-sm font-medium bg-amber-500/15 text-amber-300 border border-amber-500/20">
                                🚀 Startup Journey
                            </span>

                            <span className="px-2 py-1 rounded-full text-xs lg:text-sm font-medium bg-green-500/15 text-green-300 border border-green-500/20">
                                💚 Community Growth
                            </span>

                            <span className="px-2 py-1 rounded-full text-xs lg:text-sm font-medium bg-purple-500/15 text-purple-300 border border-purple-500/20">
                                🔍 Full Transparency
                            </span>
                        </div>
                    </>
                )}
            </div>
      </div>

      <div className="flex flex-wrap gap-1 border-t border-cyan-200 mt-2 py-2">
        <div className='ng-gray-800 border border-gray-700 rounded-lg'>
            {TABS.map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => {
                        setActiveTab(tab.key);
                        setActiveView("contest");
                    }}
                    className={`w-fit px-2 py-1 text-xs lg:text-sm  rounded-lg whitespace-nowrap transition-all
                        ${
                            activeView === "contest" && activeTab === tab.key
                                ? "bg-cyan-500 text-black font-semibold"
                                : "bg-gray-800 text-gray-200"
                        }`}
                >
                    {tab.label}
                </button>
            ))}

            <button
                onClick={() => {setActiveView("doori")}}
                className={`w-fit px-2 py-1 text-xs lg:text-sm  rounded-lg whitespace-nowrap transition-all
                    ${
                        activeView === "doori"
                            ? "bg-cyan-500 text-black font-semibold"
                            : "bg-gray-800 text-gray-200"
                    }`}
            >
                DOORI Collections
            </button>

            <button
                onClick={() => {setActiveView("parent")}}
                className={`w-fit px-2 py-1 text-xs lg:text-sm  rounded-lg whitespace-nowrap transition-all
                    ${
                        activeView === "parent"
                            ? "bg-cyan-500 text-black font-semibold"
                            : "bg-gray-800 text-gray-200"
                    }`}
            >
                Parent/Mentor Streaks
            </button>

            <button
                onClick={() => {setActiveView("local")}}
                className={`w-fit px-2 py-1 text-xs lg:text-sm  rounded-lg whitespace-nowrap transition-all
                    ${
                        activeView === "local"
                            ? "bg-cyan-500 text-black font-semibold"
                            : "bg-gray-800 text-gray-200"
                    }`}
            >
                Local Streaks
            </button>
        </div>
    </div>

    {activeView === "contest" && (
        <>
        {loading ? (
                <div className="text-center text-gray-200 text-sm py-4">
                    Loading contest data...
                </div>
            ) : !data ? (
                <p className="text-yellow-200 text-center">
                    There is No Contest Running for {activeTab}
                </p>
            ) : (
                <div className="space-y-4 text-gray-100">
                    <div className="bg-gradient-to-r from-gray-800 to-gray-900 p-2 rounded-2xl shadow-lg">
                        <h2 className="text-xs lg:text-sm font-bold text-yellow-300">
                            {data.heroTitle || "Contest"}
                        </h2>
                        <p className="text-xs lg:text-sm  text-gray-100 mt-2">
                            {data.bannerText || ""}
                        </p>
                    </div>

                    {/* META INFO */}
                    <div className="bg-gray-800 p-2 rounded-2xl space-y-2">
                        <p className="text-xs lg:text-sm text-gray-100">
                            <span className="text-gray-200">Title:</span> {data.title || "N/A"}
                        </p>

                        <p className="text-xs lg:text-sm text-gray-100">
                            <span className="text-gray-200">Sponsor:</span> {data.sponsor || "N/A"}
                        </p>

                        <p className="text-xs lg:text-sm text-gray-100">
                            <span className="text-gray-200">Campaign Ends:</span> {data.campaignEndsOn || "N/A"}
                        </p>

                        <p className="text-xs lg:text-sm text-gray-100">
                            <span className="text-gray-200">Status:</span> {data.status || "N/A"}
                        </p>
                    </div>

                    {/* PRIZE */}
                    <div className="bg-gray-800 p-2 rounded-2xl border border-gray-700">
                        <p className="text-xs lg:text-sm text-gray-200">Prize</p>
                        <h3 className="text-xs lg:text-sm text-gray-100 mt-1">
                            {data.prize || "N/A"}
                        </h3>
                    </div>

                    {/* STATS GRID */}
                    <div className="grid grid-cols-2 gap-3">
                        <div className="bg-gray-800 p-3 rounded-xl">
                            <p className="text-xs lg:text-sm text-gray-200">Target</p>
                            <p className="text-xs lg:text-sm text-gray-100">
                            {data?.targetSubscriptions?.toLocaleString?.()}
                            </p>
                        </div>

                        <div className="bg-gray-800 p-3 rounded-xl">
                            <p className="text-xs lg:text-sm text-gray-200">Streak</p>
                            <p className="text-xs lg:text-sm text-gray-100">
                            {data.streakDays || "N/A"} Days
                            </p>
                        </div>

                        <div className="bg-gray-800 p-3 rounded-xl">
                            <p className="text-xs lg:text-sm text-gray-200">Type</p>
                            <p className="text-xs lg:text-sm text-gray-100">
                            {data.contestType || "N/A"}
                            </p>
                        </div>

                        <div className="bg-gray-800 p-3 rounded-xl">
                            <p className="text-xs lg:text-sm text-gray-200">Progress</p>
                            <p className="text-xs lg:text-sm text-gray-100">
                            {data.progress || "N/A"}
                            </p>
                        </div>
                    </div>

                    {/* IMPORTANT LINKS */}
                    <div className="bg-gray-800 p-2 rounded-2xl space-y-2">
                        <p className="text-xs lg:text-sm text-gray-200">Important Links</p>

                        <a
                            href={data?.displayURL1}
                            target="_blank"
                            className="text-xs lg:text-sm text-cyan-300 underline"
                        >
                            {data?.displayLabel1}
                        </a>
                        <br/>
                        <a
                            href={data?.displayURL2}
                            target="_blank"
                            className="text-xs lg:text-sm text-cyan-300 underline"
                        >
                            {data?.displayLabel2}
                        </a>                    

                        <p className="text-xs lg:text-sm text-cyan-100">
                            Announcement: {data.winnerAnnouncementPage || "N/A"}
                        </p>
                    </div>

                    {/* ELIGIBILITY */}
                    <div className="bg-gray-800 p-2 rounded-2xl">
                        <p className="text-xs lg:text-sm text-cyan-200 mb-1">Eligibility</p>
                        <p className="text-xs lg:text-sm text-gray-100 leading-relaxed">
                            {data.prerequisite || "N/A"}
                        </p>
                    </div>

                    {/* WINNER */}
                    <div className="bg-gray-800 p-2 rounded-2xl">
                        <p className="text-xs lg:text-sm text-cyan-200">Winner Selection</p>
                        <p className="text-xs lg:text-sm text-gray-100 mt-1">
                            {data.winnerSelectionMethod || "N/A"}
                        </p>
                    </div>

                    {/* DATES */}
                    <div className="bg-gray-800 p-2 rounded-2xl grid grid-cols-2 gap-3">
                        <div>
                            <p className="text-xs lg:text-sm text-cyan-200">Start</p>
                            <p className="text-xs lg:text-sm text-gray-100">
                            {data.resultDeclarationStart || "N/A"}
                            </p>
                        </div>
                        <div>
                            <p className="text-xs lg:text-sm text-cyan-200">End</p>
                            <p className="text-xs lg:text-sm text-gray-100">
                            {data.resultDeclarationEnd || "N/A"}
                            </p>
                        </div>
                    </div>

                    {/* TRAVEL */}
                    {data.travelPartner?.isTravel && (
                        <div className="bg-gradient-to-r from-cyan-900 to-gray-900 p-2 rounded-2xl border border-cyan-700">
                            <p className="text-xs lg:text-sm text-cyan-200 font-semibold">
                                Travel Reward
                            </p>
                            <a
                                href={data?.travelPartner?.packageURL}
                                target="_blank"
                                className="text-xs lg:text-sm text-cyan-300 underline"
                            >
                                {data?.travelPartner?.packageName}
                            </a>
                            <p className="text-xs lg:text-sm text-gray-100 mt-1">
                                For: {data?.travelPartner?.travelTarget}
                            </p>
                        </div>
                    )}

                    <div className="bg-gray-900 p-3 rounded-2xl">
                        <p className="text-xs lg:text-sm text-cyan-200 mb-3 font-semibold">
                            📝 Special Remarks
                        </p>

                        <ul className="space-y-2">
                            {data?.splRemarks?.map((t, i) => (
                                <li
                                    key={i}
                                    className={`text-gray-100 text-xs lg:text-sm px-3 py-2 rounded-lg border-l-4 border-cyan-400 leading-relaxed transition-colors ${
                                        i % 2 === 0
                                            ? "bg-gray-800"
                                            : "bg-gray-900"
                                    }`}
                                >
                                    {t}
                                </li>
                            ))}
                        </ul>
                    </div>                    

                    <div className="bg-gray-900 p-3 rounded-2xl">
                        <p className="text-xs lg:text-sm text-cyan-200 mb-3 font-semibold">
                            📜 Terms & Conditions
                        </p>

                        <ul className="space-y-2">
                            {data?.termsAndConditions?.map((t, i) => (
                                <li
                                    key={i}
                                    className={`text-gray-100 text-xs lg:text-sm px-3 py-2 rounded-lg border-l-4 border-cyan-400 leading-relaxed transition-colors ${
                                        i % 2 === 0
                                            ? "bg-gray-800"
                                            : "bg-gray-900"
                                    }`}
                                >
                                    {t}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* DISCLAIMER */}
                    <div className="bg-gray-800 p-2 rounded-2xl">
                        <p className="text-xs lg:text-sm text-gray-100">
                            {data.publicDisclaimer || "N/A"}
                        </p>
                    </div>
                </div>
            )}
            </>
        )}
        {activeView === "doori" && <PDDOORIContest />}
        {activeView === "local" && <PDLocalStreak />}
        {activeView === "parent"&& <PDParentStreak />}

    </div>
    </ErrorBoundary>
  );
};

export default PDContest;